<div class="login-panl-wrappr academy-main-login clientLogin-Core3 forgot-psw-page">
  <div class="container-fluid">
    <div class="row m-0">
      <!-- Left Column: Form & Ecosystem -->
      <div class="col-12 col-md-12 col-lg-6 login-container loginLeft-panel">
        <div class="animated-bg d-lg-block d-none">
          <div class="blob blob-1"></div>
          <div class="blob blob-2"></div>
          <div class="blob blob-3"></div>
        </div>

        <div class="mx-auto login-container-info">
          <!-- Logo & Header -->
          <div class="sticky-top animate-fade-up delay-1">
            <div class="logo">
              <div class="logo-box">
                <span class="caps">academy</span>
                <span class="smal">by CCS</span>
              </div>
            </div>

            <div *ngIf="!linkGenerated">
              <h1>Forgot password?</h1>
              <p class="subTittle">Reset your password with CCS ACADEMY. Enter your email to receive instructions.</p>
            </div>

            <div *ngIf="linkGenerated">
              <h1>Check your email</h1>
              <p class="subTittle">A password reset link has been dispatched to your email address.</p>
            </div>
          </div>

          <!-- Form Area (Initial State) -->
          <div class="form-wrppr-box animate-fade-up delay-3" *ngIf="!linkGenerated">
            <form [formGroup]="forgotPasswordForm" autocomplete="off" (ngSubmit)="onSubmit()" (keydown.enter)="$event.stopPropagation(); onSubmit()">
              <label class="inputLabel">Email address<span>*</span></label>
              <div class="mb-3">
                <input
                  type="email"
                  class="form-control"
                  formControlName="email"
                  placeholder="Enter your email"
                  required
                />
                <div class="ErrorMessageSection mt-1">
                  <p *ngIf="submitted && forgotPasswordForm.get('email')?.hasError('required')" class="text-danger small mb-0 mt-1">
                    Please enter your email
                  </p>
                  <p *ngIf="submitted && forgotPasswordForm.get('email')?.hasError('email') && !forgotPasswordForm.get('email')?.hasError('required')" class="text-danger small mb-0 mt-1">
                    Please enter a valid email address
                  </p>
                </div>
              </div>

              <button
                type="submit"
                class="btn-sso signIn-btn w-100 mb-3"
                [disabled]="forgotPasswordForm.pristine || dataLoaded"
              >
                Send Reset Link <i class="fa-solid fa-arrow-right ms-2"></i>
              </button>

              <div class="d-flex justify-content-center">
                <a routerLink="/" class="forgetPsw back-btn-link">
                  <i class="fa-solid fa-arrow-left me-1"></i> Back to Sign In
                </a>
              </div>
            </form>
          </div>

          <!-- Success State (Link Generated) -->
          <div class="form-wrppr-box animate-fade-up delay-3 success-panel" *ngIf="linkGenerated">
            <div class="success-message-card mb-4">
              <div class="success-icon-wrap mb-2">
                <i class="fa-solid fa-circle-check"></i>
              </div>
              <p class="success-text mb-0">
                A link has been sent to you to reset your password. Please check your inbox and follow the instructions.
              </p>
            </div>

            <button type="button" class="btn-sso signIn-btn w-100 mb-3" routerLink="/">
              Back to Sign In <i class="fa-solid fa-arrow-right ms-2"></i>
            </button>

            <div class="d-flex justify-content-center">
              <a href="javascript:void(0)" (click)="linkGenerated = false" class="forgetPsw resend-link">
                <i class="fa-solid fa-rotate-left me-1"></i> Try another email
              </a>
            </div>
          </div>

          <!-- Our Ecosystem Section -->
          <!-- <div class="ourEcosystm-card animate-fade-up delay-4">
            <p class="tittle fw-bold">OUR ECOSYSTEM</p>
            <div class="grid">
              <div class="card-info">
                <a [href]="ecosystemLinks.connect" target="_blank" [class.disabled-link]="!ecosystemLinks.connect">
                  <div class="eco-card">
                    <div class="eco-icon dollar"><img src="../../../../assets/images/euro.png" alt="connect png"></div>
                    <p>CORE Connect</p>
                  </div>
                </a>
              </div>
              <div class="card-info">
                <a [href]="ecosystemLinks.hub" target="_blank" [class.disabled-link]="!ecosystemLinks.hub">
                  <div class="eco-card">
                    <div class="eco-icon"><img style="transform: scale(1.5);" src="../../../../assets/images/icon-academy.png" alt="academy png"></div>
                    <p>CORE Hub</p>
                  </div>
                </a>
              </div>
              <div class="card-info">
                <a [href]="ecosystemLinks.projects" target="_blank" [class.disabled-link]="!ecosystemLinks.projects">
                  <div class="eco-card">
                    <div class="eco-icon"><img src="../../../../assets/images/icon-projects.png" alt="projects png"></div>
                    <p>CORE Projects</p>
                  </div>
                </a>
              </div>
            </div>
          </div> -->

          <!-- Having Trouble Footer -->
          <div class="text-center havingTrouble-info animate-fade-up delay-5">
            <p>Having trouble? <a href="mailto:it@ccscleaning.com" class="contact-link">it&#64;ccscleaning.com</a></p>
            <p class="ccs-copyright">© 2026 ccsacademy</p>
          </div>
        </div>
      </div>

      <!-- Right Column: Hero Banner matching Login -->
      <div class="col-md-12 col-lg-6 hero-section loginRight-panel image-card-info position-relative">
        <div class="panel-bg-image" style="background-image: url(../../../../assets/images/login-hero-staff-banner.jpg);"></div>

        <div class="status-pill animate-fade-down delay-1">
          <span class="dot"></span> All Systems Operational
        </div>

        <div class="image-card-info-wrapper">
          <div class="mb-4 badges-wrapper animate-fade-up delay-2">
            <span class="badge-outline">Staff Management</span>
            <span class="badge-outline">Audit & Compliance</span>
          </div>

          <h2 class="main-tittle animate-fade-up delay-3">Our operations,<br><span>one dashboard</span></h2>
          <p class="subTittle animate-fade-up delay-4">
            Manage sites, teams, audits, and service delivery — all from a single platform built for our workflow.
          </p>

          <div class="d-flex gap-5 count-info animate-fade-up delay-5">
            <div class="metric-item">
              <h3 class="fw-bold mb-0">700+</h3>
              <p class="small opacity-75">Sites Managed</p>
            </div>
            <div class="metric-item">
              <h3 class="fw-bold mb-0">2k</h3>
              <p class="small opacity-75">Active Staff</p>
            </div>
            <div class="metric-item">
              <h3 class="fw-bold mb-0">99.9%</h3>
              <p class="small opacity-75">System Uptime</p>
            </div>
          </div>

          <p class="small fw-bold build-for-us opacity-50 mb-0 pt-4 animate-fade-in delay-5">BUILT BY US - FOR US</p>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="spinner-wrapper" *ngIf="dataLoaded">
  <div class="spinner"></div>
</div>